import React, { useEffect, useRef, useState } from "react";
import { scroll, toFilterData } from "../../../../components/utils/utils";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../apis/store";
import { Row } from "antd";
import PaginationComponent from "../../../../biblio/Pagination/PaginationComponent";
import DotsLoader from "../../../../biblio/Loader/DotsLoader";
import SponsorBookingOverview from "./SponsorBookingOverview";
import { getAllSponsorBooking } from "../../../../apis/actions/sponsor.actions";
import CustomConfigProvider from "../../ProfileHeader";
const SponsorBooking = () => {
  const dispatch = useDispatch<AppDispatch>();
  const currentRef = useRef<HTMLDivElement>(null);

  const { sponsorBooking, loading } = useSelector(
    (state: RootState) => state?.sponsor
  );

  const [selectedFilter] = useState<string | null>(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [state, setState] = useState({
    year: "",
    month: "",
  });
  const [filteredRequests, setFiltredRequests] = useState<any[]>([]);
  const OtpId =  useSelector(
    (state: RootState) => state?.recipient?.OtpId
  );
  useEffect(() => {
    dispatch(getAllSponsorBooking({ sponsor_id: OtpId }));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  useEffect(() => {
    let list = selectedFilter
      ? sponsorBooking?.filter(
          (request: any) => request.request_type_id === selectedFilter
        )
      : sponsorBooking;

    setCurrentPage(1);
    setFiltredRequests(toFilterData(list, state));
  }, [sponsorBooking, selectedFilter, state]);

  const updateActive = (nb: number) => {
    setCurrentPage(nb);
    scroll(currentRef);
  };
  const itemPerPage = 4;

  return (
    <>
      <CustomConfigProvider
        title=" الحجوزات الغير مدفوعة"
        withdateFilter={true}
        filterState={state}
        setState={(values) => setState(values)}
      ></CustomConfigProvider>

      {loading ? (
        <div
          className="takaful--loading-projects-cases"
          style={{ marginTop: "5rem" }}
        >
          <p className="takaful--no-project-message"> جارٍ التحميل</p>
          <DotsLoader />
        </div>
      ) : sponsorBooking?.length === 0 ? (
        <p className="takaful--no-services" style={{ marginTop: "5rem" }}>
          لا توجد حجوزات
        </p>
      ) : filteredRequests?.length === 0 ? (
        <p className="takaful--no-services" style={{ marginTop: "5rem" }}>
          لا يوجد حجوزات تتوافق مع البحث الذي قمت به
        </p>
      ) : (
        <>
          <Row gutter={[16, 48]} justify={"space-around"} ref={currentRef}>
            <SponsorBookingOverview
              requests={filteredRequests?.slice(
                (currentPage - 1) * itemPerPage,
                (currentPage - 1) * itemPerPage + itemPerPage
              )}
            />
          </Row>
          <div className="takaful--pagination-container">
            {filteredRequests && filteredRequests?.length > itemPerPage && (
              <PaginationComponent
                active={currentPage}
                total={filteredRequests?.length}
                itemPerPage={itemPerPage}
                scroll={() => scroll(currentRef)}
                setActive={(nb) => updateActive(nb)}
              />
            )}
          </div>
        </>
      )}
    </>
  );
};

export default SponsorBooking;
